<template>
    <van-popup v-model="showError" :close-on-click-overlay="false">
      <div class="error">
        <div class="title">请求错误</div>
        <div class="content">
          请求了错误的链接，如有疑问，请联系群主或管理员。
        </div>
      </div>
    </van-popup>
</template>

<script>
export default {
  name: 'Err',
  data() {
    return {
      showError: true,
    }
  },
}
</script>
<style lang="scss" scoped>
.error {
  width: 90vw;
  padding: 6px 12px;
  .title {
    font-size: 18px;
    padding: 6px 0 12px;
    border-bottom: 1px solid #999;
    margin-bottom: 6px;
    text-align: center;
  }
  .content {
    padding: 6px 0;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
</style>
